/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_Link_Failed_TitleInputs */



/**
* | output |
* | --- |
* | "Connecting did not work" |
*
* @param {Connections_Link_Failed_TitleInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const connections_link_failed_title = /** @type {((inputs?: Connections_Link_Failed_TitleInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_Link_Failed_TitleInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Koppelen niet gelukt")
	if (locale === "fr") return /** @type {LocalizedString} */ ("La connexion n'a pas fonctionné")
	return /** @type {LocalizedString} */ ("Connecting did not work")
});